export type CreatePurchasePayload = {
  email: string;
  firstName: string;
  lastName: string;
  organizationName: string;
  BIData: Record<string, unknown>;
  currency?: string;
};

export type CreatePurchaseResponse = {
  uuid?: string;
  stripe_invoice?: string;
  stripe_invoice_id?: string;
};

export const createPurchase = async ({
  email,
  firstName,
  lastName,
  organizationName,
  BIData,
  currency = "usd",
}: CreatePurchasePayload): Promise<CreatePurchaseResponse> => {
  const query = `
    mutation CREATE_PURCHASE($params: CreatePurchaseInput!) {
      create_purchase(params: $params) {
        uuid
        stripe_invoice
        stripe_invoice_id
      }
    }
  `;

  const variables = {
    params: {
      email,
      first_name: firstName,
      last_name: lastName,
      organization_name: organizationName,
      data: BIData,
      currency,
    },
  };

  const res = await fetch(import.meta.env.VITE_PURCHASE_URL, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      query,
      variables,
      operationName: null,
    }),
  });

  const json = await res.json();

  if (json.errors) {
    throw new Error(json.errors[0].message);
  }

  return json.data.create_purchase;
};
